import {
  Button,
  Divider,
  Icon,
  RemoveAlertDialog,
  Text,
  useDisclosure,
  VStack,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { usePostOfferToAnva } from '@flows/src/api/anva-flows/postOfferToAnva';
import AnvaSendOfferStatus from '@flows/src/components/flow-products/quotes/basket/actions/AnvaSendOfferStatus';
import { AnvaInsurancePoliciesDocumentList } from '@flows/src/components/flow-products/quotes/basket/actions/AnvaInsurancePoliciesDocumentList';
import AnvaQuoteInlineError from '@flows/src/components/flow-products/quotes/AnvaQuoteInlineError';
import AnvaEmailOfferAccordion from '@flows/src/components/flow-products/quotes/basket/actions/AnvaEmailOfferAccordion';

interface Props {
  sessionId: string;
  isPlural?: boolean;
}

const AnvaOfferSelectionOverviewButton = ({ sessionId, isPlural }: Props) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { data, mutate, isError, error, status, isSuccess } =
    usePostOfferToAnva({});
  const title = isPlural
    ? t('FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_PLURAL')
    : t('FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_SINGULAR');
  const handleClick = () => {
    onOpen();
    try {
      if (!isSuccess) {
        mutate({ sessionId });
      }
    } finally {
      // onClose();
    }
  };

  return (
    <>
      <RemoveAlertDialog
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        onConfirm={onClose}
        confirmButtonText={t('CLOSE')}
        hideCancelButton
        variant="ghost"
        size="2xl"
      >
        <VStack spacing="4" align="stretch">
          <Text textStyle="smallBody" color="gray.500">
            {t('FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_DESCRIPTION')}
          </Text>
          <Divider color="gray.50" />
          {isError ? (
            <VStack px="5" pb="4">
              <AnvaQuoteInlineError
                error={(error as Error)?.message ?? ''}
                title={t(
                  'FLOWS_PRODUCTS_BASKET_ACTIONS_ANVA-OFFER_STATUS_ERROR_SINGULAR',
                )}
                introKey={'FLOWS_PRODUCTS_QUOTE_ANVA-OFFER-ERROR-INTRO'}
              />
            </VStack>
          ) : (
            <AnvaSendOfferStatus status={status} isPlural={isPlural} />
          )}
          {data &&
            [...data.insurance_policies, ...data.policy_packages].length >
              0 && <AnvaInsurancePoliciesDocumentList data={data} />}
          <AnvaEmailOfferAccordion sessionId={sessionId} documents={data} />
        </VStack>
      </RemoveAlertDialog>
      <Button
        onClick={handleClick}
        leftIcon={
          <Icon
            name={
              isSuccess
                ? 'GeneralStatusSuccessCheckmark'
                : 'GeneralActionsSendTo'
            }
          />
        }
        variant={isSuccess ? 'successGhost' : 'secondary'}
      >
        {title}
      </Button>
    </>
  );
};

export default AnvaOfferSelectionOverviewButton;
